import { render } from "./WeeklySales.vue?vue&type=template&id=52b45194&scoped=true"
import script from "./WeeklySales.vue?vue&type=script&lang=js"
export * from "./WeeklySales.vue?vue&type=script&lang=js"

import "./WeeklySales.vue?vue&type=style&index=0&id=52b45194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b45194"]])

export default __exports__